export default "__VITE_ASSET__$5d5_HFn__"